import type { Namespace } from "@/i18n/types";
import nsViewEN from "./en";
import nsViewJA from "./ja";

export const nsView = {
  name: "view",
  locales: {
    ja: nsViewJA,
    en: nsViewEN,
  },
} satisfies Namespace<"view", typeof nsViewJA>;
